import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-dv-auth-login',
  templateUrl: './dv-auth-login.component.html',
  styleUrls: ['./dv-auth-login.component.scss']
})
export class DvAuthLoginComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private DateServiceObj: DataService) { }

  ngOnInit(): void {
    let Data: any;
    this.route.queryParams.subscribe(queryParams => {
    const encodedData = queryParams.newData;
    const returnUrl = encodedData ? JSON.parse(decodeURIComponent(encodedData)) : undefined;
    console.log('Received returnUrl:', returnUrl.token);

    console.log('Received returnUrl:', returnUrl);

    this.DateServiceObj.setUserToken(returnUrl.token);
    const data1 = returnUrl;
    data1.Data.id = returnUrl.Data.subscriberId;
    console.log('returnedCreatedData', data1);
    sessionStorage.setItem('subscriberLogin', JSON.stringify(data1));

    const usertoken = this.DateServiceObj.getUserToken();
    console.log('userToken', usertoken, returnUrl.token);
    // "tableName":"txnUsers","isDeviceExpired":false,
    // "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ODgsInVzZXJuYW1lIjoidW5kZWZpbmVkdW5kZWZpbmVkIiwiZW1haWwiOiJhenVyZS5kZXYwMDFAeW9wbWFpbC5jb20iLCJpYXQiOjE3MjkyNDY1OTYsImV4cCI6MTcyOTMzMjk5Nn0.sMrNAjZ86Vr5HbSaBUjFJPXtc4wQdTRT3K-loEmIjHY"};
    // this.DateServiceObj.setUserToken(Data.token);
    //   sessionStorage.setItem('subscriberLogin', JSON.stringify(Data))
    if (sessionStorage.getItem('subscriberLogin')) {
      // Navigate to the home URL
      this.router.navigate(['/home']);

    }
  });
  }

}
